import { StatsAdapterInterface } from '../../../stats/adapter.interface';
import { StatsContextInterface } from '../../../stats/context.interface';
import { GtmStatsDataEventCustomCtaClickInterface } from '../data/event-custom-cta-click.interface';

export class GtmStatsAdapterEventCustomCtaClick implements StatsAdapterInterface {
  /**
   *
   * @param context
   */
  constructor(protected context: StatsContextInterface) {}

  /**
   * @inheritDoc
   */
  public getData(): GtmStatsDataEventCustomCtaClickInterface {
    if (!this.context.local.cta) {
      throw new Error('Stats local context "cta" is not set.');
    }

    // CTA: custom event
    if (this.context.local.cta.customEvent) {
      return this.getEvent(
        this.context.local.cta.customEvent.name,
        this.context.local.cta.customEvent.action,
        this.context.local.cta.customEvent.label
      );
    }

    throw new Error('GtmStatsAdapterEventCustomCtaClick is unable to define the event.');
  }

  /**
   * Get sanitized event
   *
   * @param name
   * @param action
   */
  private getEvent(name: string, action: string, label: string): GtmStatsDataEventCustomCtaClickInterface {
    const event: GtmStatsDataEventCustomCtaClickInterface = {
      event: name,
      eventAction: action,
      eventLabel: label,
    };

    if (!event.event) {
      throw new Error('GtmStatsAdapterEventCustomCtaClick is unable to define the event name.');
    }

    if (!event.eventAction) {
      throw new Error('GtmStatsAdapterEventCustomCtaClick is unable to define the event action.');
    }

    if (!event.eventLabel) {
      // Remove eventLabel field if it is not defined
      delete event.eventLabel;
    }

    return event;
  }
}
